import {
  AccountBalance,
  Agriculture,
  ArticleOutlined,
  BackupTable,
  Dashboard,
  Group,
  LocalShipping,
  Newspaper,
  ShoppingCart,
  Storefront,
} from "@mui/icons-material";

export const menu = [
  {
    title: "Dashboard",
    icon: <Dashboard />,
    path: "/admin",
    items: [],
  },
  {
    title: "Master Data",
    icon: <BackupTable />,
    items: [
      {
        title: "Aktifitas Petani",
        path: "/admin/aktifitas",
      },
      {
        title: "Area",
        path: "/admin/area",
      },
      {
        title: "Bank",
        path: "/admin/bank",
      },
      {
        title: "Jabatan",
        path: "/admin/jabatan",
      },
      {
        title: "Role",
        path: "/admin/role",
      },
      {
        title: "Satuan Berat",
        path: "/admin/satuan-berat",
      },
      {
        title: "Tipe Harga",
        path: "/admin/tipe-harga",
      },
      {
        title: "Tipe Sayuran",
        path: "/admin/tipe-sayuran",
      },
    ],
  },
  {
    title: "User Menu",
    icon: <Group />,
    path: "/admin/user-management",
    items: [
      {
        title: "Karyawan",
        path: "/admin/karyawan",
      },
      {
        title: "Petani",
        path: "/admin/petani",
      },
      {
        title: "Status Karyawan",
        path: "/admin/status-karyawan",
      },
      {
        title: "User Management",
        path: "/admin/user-management",
      },
    ],
  },
  {
    title: "Data Sayuran",
    icon: <ShoppingCart />,
    items: [
      {
        title: "Harga Sayuran",
        path: "/admin/harga-sayuran",
      },
      {
        title: "Sayuran",
        path: "/admin/sayuran",
      },
    ],
  },
  {
    title: "Data Customer",
    icon: <Storefront />,
    items: [
      {
        title: "Customer",
        path: "/admin/customer",
      },
      {
        title: "Customer Group",
        path: "/admin/customer-group",
      },
      {
        title: "Customer Region",
        path: "/admin/customer-region",
      },
    ],
  },
  {
    title: "Data Operational",
    icon: <LocalShipping />,
    items: [
      {
        title: "Kategori Produk",
        path: "/admin/kategori-produk",
      },
      {
        title: "Kendaraan Pengiriman",
        path: "/admin/kendaraan-pengiriman",
      },
      {
        title: "Produk Operational",
        path: "/admin/produk-operational",
      },
    ],
  },
  {
    title: "Petani",
    icon: <Agriculture />,
    items: [
      {
        title: "Aktifitas Harian",
        path: "/petani/aktifitas-harian",
      },
      {
        title: "Estimasi Panen",
        path: "/petani/estimasi-panen",
      },
      {
        title: "Panen",
        path: "/petani/panen",
      },
      {
        title: "Hutang Plastik",
        path: "/petani/hutang-plastik",
      },
      {
        title: "Hutang Petani",
        path: "/petani/hutang",
      },
    ],
  },
  {
    title: "Laporan",
    icon: <ArticleOutlined />,
    items: [
      {
        title: "Aktifitas Petani",
        items: [
          {
            title: "Beraktifitas",
            path: "/spv/laporan/aktifitas-petani/beraktifitas",
          },
          {
            title: "Detail",
            path: "/spv/laporan/aktifitas-petani/detail",
          },
          {
            title: "Tidak Beraktifitas",
            path: "/spv/laporan/aktifitas-petani/tidak-beraktifitas",
          },
          {
            title: "Semua Petani",
            path: "/spv/laporan/aktifitas-petani",
          },
        ],
      },
      {
        title: "Estimasi Panen",
        items: [
          {
            title: "Estimasi Panen",
            path: "/spv/laporan/estimasi-panen",
          },
          {
            title: "Estimasi Panen Petani",
            path: "/spv/laporan/estimasi-panen/petani",
          },
        ],
      },
      {
        title: "Panen",
        items: [
          {
            title: "Panen",
            path: "/spv/laporan/panen",
          },
          {
            title: "Panen Petani",
            path: "/spv/laporan/panen/petani",
          },
        ],
      },
    ],
  },
  {
    title: "Admin",
    icon: <Newspaper />,
    items: [
      {
        title: "Nota Petani",
        path: "/petani/nota-petani",
      },
      {
        title: "PO Toko",
        path: "/admin/po-toko",
      },
      {
        title: "Stock Sayuran",
        path: "/admin/stock-sayuran",
      },
      {
        title: "Stock Barang",
        path: "/admin/stock-barang-operational",
      },
      {
        title: "Surat Jalan",
        path: "/admin/surat-jalan",
      },
      {
        title: "Invoice",
        path: "/admin/invoice",
      },
      {
        title: "Pengajuan Operasional",
        path: "/admin/pengajuan-operasional",
      },
    ],
  },
  {
    title: "Keuangan",
    icon: <AccountBalance />,
    items: [
      {
        title: "Pembayaran Nota",
        path: "/admin/keuangan/pembayaran-nota",
      },
    ],
  },
];
